<template>
    <div>
        <div v-for="file in files" :key="file.id">
            <FileQuestionItem :file="file" />
        </div>
    </div>
</template>

<script>
import FileQuestionItem from "./FileQuestionItem.vue";

export default {
    name: "file-question",
    components: {
        FileQuestionItem,
    },
    props: {
        question: {
            type: Object,
            required: true,
        },
    },
    computed: {
        files() {
            return this.question.answer;
        },
    },
};
</script>